import type { IconProps } from '../types/IconProps.ts';
export const Plus: IconProps = {
    name: 'Plus',
    children: [
        `<path d="M12 5v14M5 12h14" />`,
    ]
};